import includes from 'lodash/includes';
import { expiryDate } from './FormValidation';

export const timestampToDate = (timestamp = -1, yearLen) => {
  if (timestamp && timestamp > 0) {
    const utcStr = new Date(timestamp).toUTCString();
    const d = new Date(utcStr);
    if (yearLen === 2) {
      const options = { year: '2-digit', month: 'numeric', day: 'numeric' };
      return d.toLocaleDateString('en-US', options);
    }

    return d.toLocaleDateString('en-US');
  }
  return '';
};

// format string date to mm/dd/yyyy format
export const getFormattedDate = (strDate) => {
  if (strDate && strDate.includes('Z')) {
    /**
     * following replace is to fix the date format issue
     * The "Z" is a zero time offset. When it includes in the string,
     * "1978-11-11T00:00:00.000Z" returns 11/10/1978 (one day off)
     * From rfc3339: A suffix which, when applied to a time, denotes a UTC
       offset of 00:00; often spoken "Zulu" from the ICAO
       phonetic alphabet representation of the letter "Z"
     */
    const sanitizedDate = strDate.replace(/Z/, '');
    const utcStr = new Date(sanitizedDate).toUTCString();
    const options = { month: '2-digit', day: '2-digit', year: 'numeric', timeZone: 'UTC' };
    const date = new Date(utcStr).toLocaleDateString('en-US', options);
    return date;
  }

  // This handles normal dates that don't have time offset
  if (strDate) {
    const date = new Date(strDate);
    const year = date.getFullYear();
    const month = (1 + date.getMonth()).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${month}/${day}/${year}`;
  }

  return strDate;
};

export const formatCardTypes = (cardType) => {
  switch (cardType) {
    case 'visa':
      return 'Visa';
    case 'mastercard':
      return 'MasterCard';
    case 'amex':
      return 'American Express';
    case 'discover':
      return 'Discover';
    default:
      return null;
  }
};

export const formatCardTypeImgPath = (cardType) => {
  if (cardType) {
    return cardType.toLocaleLowerCase().replace(' ', '-');
  }
  return cardType;
};

export const capitalizeFirstLetter = (str) => {
  if (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

export const formatGenderValue = (v) => {
  const gender = v && v.toLowerCase();

  switch (gender) {
    case 'f':
      return 'Female';
    case 'm':
      return 'Male';
    case 'o':
      return 'Prefer not to say';
    case 'unspecified':
      return 'Prefer not to say';
    default:
      return v && capitalizeFirstLetter(v);
  }
};

export const formatGenderToSend = (v) => (v === 'o' ? 'Unspecified' : v);

export const formatGenderText = (v) => {
  const gender = v && v.toLowerCase();

  switch (gender) {
    case 'female':
      return 'f';
    case 'male':
      return 'm';
    case 'unspecified':
      return 'o';
    default:
      return v;
  }
};

/**
 * for the update form, we need to reset the form firstName to empty of the
 * fName has email elements to it which the backend sends when the fname is empty
 */
export const resetFirstNameIfHasEmail = (fName, lName, email) => {
  if (!lName && email && includes(email, fName)) {
    return '';
  }
  return fName;
};

export const formatDateRange = (startDate, endDate) => {
  // startDate and endDate may be returned -1, if that is the case, we don't show it
  const startRange = timestampToDate(startDate, 2);
  const dateRange =
    startRange && endDate && endDate !== -1 ? `${startRange}-${timestampToDate(endDate, 2)}` : startRange;

  return dateRange;
};

/**
 * format 'mm/yy' to 'mm/yyyy'
 * If value is not in 'mm/yy', we will not format it, just return the value.
 * Since Evergent doesn't support 'mm/yy' in their addSubscription and updatePaymentInfo
 * APIs at this moment, we will prepent 20 in front of two digit years. Ex: 11/18 will return 11/2018.
 * NOTE: In 83 years from 2018, this four digit year formating needs to be updated since year 2101 will
 * become 2001
 * @param {*} value
 */
export const formatExpiryDate = (value) => {
  // check if value is a valid formated credit card expiration;
  if (value && expiryDate(value) === undefined) {
    // remove white-space characters
    const strDate = value.replace(/\s+/g, '');
    // format 'mm/yy' to 'mm/yyyy': ex 11/18 to 11/2018
    return strDate.substr(0, 3) + 20 + strDate.substr(-2);
  }
  return value;
};
